'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoChevronUp = function IoChevronUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 16.7l-13.6 13.1c-0.3 0.3-0.9 0.3-1.2 0l-2.5-2.4c-0.3-0.3-0.3-0.9 0-1.2l16.7-16c0.1-0.1 0.4-0.2 0.6-0.2s0.5 0.1 0.6 0.2l16.7 16c0.3 0.3 0.3 0.9 0 1.2l-2.5 2.4c-0.3 0.3-0.9 0.3-1.2 0l-13.6-13.1z' })
        )
    );
};

exports.default = IoChevronUp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/chevron-up.js
// module id = 1989
// module chunks = 0